<script setup lang="ts">
import type { ContactSection, ContactSectionDetail } from '~/types/api'

const items = ref<ContactSectionDetail[]>([])

/**
 * TODO get all pages
 */
const { data: result, status } = await useLazyAsyncData(() =>
  createContactSectionsRepository().getAll()
)

watch(
  result,
  async () => {
    const promises =
      result.value?.items.map((item: ContactSection) => {
        return useAsyncData(item.nid.toString(), () =>
          createContactSalesmenRepository().getAllBySectionNid(item.nid)
        )
      }) || []

    const values = await Promise.allSettled(promises)

    // TODO: Why is the type different?
    items.value =
      result.value?.items.map((item: ContactSection, index: number) => {
        const contactSalesman = values[index]

        return {
          ...item,
          salesmen: isFulfilled(contactSalesman)
            ? contactSalesman.value?.data.value?.items
            : [],
        }
      }) || []
  },
  { immediate: true }
)
</script>

<template>
  <div>
    <div v-if="status === 'pending'">
      <UiSkeletonSalesmen />
    </div>
    <div v-else>
      <ContactSalesmenSection
        v-for="item in items"
        :key="item.nid"
        :salesmen="item.salesmen ?? []"
        :title="item.name ?? ''"
      />
    </div>
    <!-- TODO: Should we show fallback here? -->
  </div>
</template>

<style scoped></style>
